import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import Button from 'components/Form/Button';
import TrashBin from 'svg/trash-bin.svg';
import { useCustomRanges } from 'modules/PatientResults/hooks';
import styles from '../GlucoseConcentrationTrend.pcss';
const RemoveCustomRangeBtn = ({ idx, tickValues, isReadOnly, updatePhiSet })=>{
    const customRanges = useCustomRanges();
    if (tickValues.length <= 2 || isReadOnly) {
        return null;
    }
    const onRemoveCustomRange = ()=>{
        const updatedCustomRanges = [
            ...customRanges
        ];
        if (!idx) {
            updatedCustomRanges[1] = [
                0,
                0,
                customRanges[1][2]
            ];
        }
        updatedCustomRanges.splice(idx, 1);
        updatePhiSet({
            customRanges: updatedCustomRanges
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        className: styles.customRange__label__actions,
        children: /*#__PURE__*/ _jsx(Button, {
            styleModifier: "transparent",
            className: cn(styles.customRange__label__action),
            onClick: onRemoveCustomRange,
            children: /*#__PURE__*/ _jsx(TrashBin, {
                className: styles.customRange__label__icon
            })
        })
    });
};
export default RemoveCustomRangeBtn;
